<template>
  <div class="record-detail-page">
    <!-- 服务记录详情列表（接口按项目返回多条记录，每条都是完整详情，时间倒序，加载更多） -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.serviceRecordId" class="detail-card">
        <div class="task-name">{{ item.projectName }}</div>
        <div class="meta-line">{{ item.merName }}</div>
        <div class="meta-line">服务时间：{{ formatTime(item.serviceTime) }}</div>
        <div class="meta-line">服务地点：{{ item.locaction }}</div>
        <div class="meta-line">服务内容：{{ item.content }}</div>

        <!-- 服务成果：现场照片 + 成果附件（置于服务内容下方，不单独成卡） -->
        <div v-if="(item.picList && item.picList.length) || (item.fileList && item.fileList.length)" class="result-block">
          <div class="result-title">服务成果</div>
          <!-- 现场照片（点击页内查看大图，可左右滑动切换） -->
          <div v-if="item.picList && item.picList.length" class="pic-grid">
            <div v-for="(pic, i) in item.picList" :key="i" class="pic-item" @click="onPreviewPic(item, i)">
              <van-image :src="pic.filePath" fit="cover" class="pic-img" />
            </div>
          </div>
          <!-- 成果附件（点击下载，避免跳转出现安全提示） -->
          <div v-for="(file, i) in item.fileList" :key="i" class="file-item">
            <a :href="file.filePath" class="file-link" @click.prevent="downloadFile(file)">
              <van-icon name="description" class="file-icon" />
              <span class="file-name">{{ fileName(file.filePath) }}</span>
            </a>
          </div>
          <!-- 企业确认状态：有确认时间显示绿色已确认+时间，否则灰色未确认 -->
          <div class="confirm-time" :class="item.confirmTime ? 'confirmed' : 'unconfirmed'">
            {{ item.confirmTime ? `企业已确认 ${formatTime(item.confirmTime)}` : '' }}
          </div>
        </div>
      </div>
    </van-list>

    <!-- 4. 底部固定返回按钮 -->
    <div class="bottom-bar">
      <van-button class="back-btn" type="default" @click="$router.back()">返回</van-button>
    </div>
  </div>
</template>
<script>
import { ImagePreview, NavBar } from 'vant'
import axios from 'axios'
import requestHomeAPI from '@/axios/HomeApi'

export default {
  name: 'ServiceRecordDetail',
  components: {
    [NavBar.name]: NavBar
  },
  data () {
    return {
      // 项目id（来自服务记录列表页）
      projectId: '',
      // 服务记录详情列表（接口按项目返回，每条都是完整详情）
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10
    }
  },
  created () {
    this.projectId = this.$route.query.projectId || ''
    if (!this.projectId) {
      this.$notify({ type: 'danger', message: '缺少项目ID' })
      return
    }
    this.onLoad()
  },
  methods: {
    // van-list 触底加载一页（接口按时间倒序返回）
    onLoad () {
      this.loading = true
      requestHomeAPI.serviceRecordDetails({
        projectId: Number(this.projectId),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res.data.code === '0000') {
          const data = res.data.data || {}
          const rows = data.rows || []
          // 追加到列表末尾（加载更多）
          this.list = this.list.concat(rows)
          const total = data.total || 0
          this.pageNum++
          // 结束条件：数据到齐，或本页不足一页（服务端 total 与实际条数不一致时防止无限翻页）
          if (this.list.length >= total || rows.length < this.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.finished = true
        this.$notify({ type: 'danger', message: '加载失败，请重试' })
      }).finally(() => {
        this.loading = false
      })
    },
    // 从文件地址中提取文件名
    fileName (filePath) {
      return (filePath || '').split('/').pop()
    },
    // 点击现场照片：页内查看大图（不跳转页面，无微信安全提示）
    onPreviewPic (item, index) {
      const images = (item.picList || []).map(pic => pic.filePath).filter(Boolean)
      if (!images.length) {
        return
      }
      ImagePreview({
        images,
        startPosition: index,
        closeable: true
      })
    },
    // 点击成果附件：blob 方式下载（安卓微信/普通浏览器可用；OSS 需配置 CORS），失败降级为新窗口打开
    downloadFile (file) {
      const url = file.filePath
      if (!url) {
        return
      }
      const name = this.fileName(url)
      const loading = this.$toast.loading({ message: '下载中...', duration: 0, forbidClick: true })
      axios({
        method: 'get',
        url,
        responseType: 'blob'
      }).then(res => {
        const blob = res.data
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = name
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(objectUrl)
      }).catch(() => {
        // 请求失败（如 OSS 未开跨域）：降级跳转原地址，微信内会弹安全提示
        window.open(url)
      }).finally(() => {
        loading.clear()
      })
    },
    // 服务时间格式化：接口返回 UTC（2026-08-19T15:17:22.000+0000），转本地时间输出 2026-08-19 23:17:22
    formatTime (time) {
      if (!time) {
        return ''
      }
      // 时区 +0000 写法 iOS Safari 解析不了，补冒号转标准 ISO 再解析
      const date = new Date(String(time).replace(/([+-]\d{2})(\d{2})$/, '$1:$2'))
      if (isNaN(date.getTime())) {
        return time
      }
      const pad = num => (num < 10 ? '0' + num : '' + num)
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 */
.record-detail-page {
  min-height: 100%;
  padding-bottom: 160px; /* 给底部固定按钮留出空间 */
  background: #f5f5f5;
  overflow: hidden;
}

/* 任务信息卡片 */
.detail-card {
  margin: 20px;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  text-align: left;

  .task-name {
    font-size: 36px; /* 渲染18px */
    font-weight: 600;
    color: #323233;
    margin-bottom: 12px;
  }

  .meta-line {
    font-size: 26px;
    color: #999;
    line-height: 42px;
  }
}

/* 服务成果（位于服务内容下方，不单独成卡） */
.result-block {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f5f5f5;

  .result-title {
    font-size: 28px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 16px;
  }

  /* 现场照片缩略图（点击页内查看大图） */
  .pic-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .pic-item {
      display: block;
      width: 160px; /* 渲染80px */
      height: 160px;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;

      .pic-img {
        width: 100%;
        height: 100%;
      }
    }
  }

  /* 成果附件行（点击下载） */
  .file-item {
    margin-top: 12px;
    margin-bottom: 12px;

    .file-link {
      display: flex;
      align-items: center;
      font-size: 26px;
      color: #1989fa; /* 蓝色链接 */
      text-decoration: none;

      .file-icon {
        margin-right: 8px;
        color: #1989fa;
      }

      .file-name {
        word-break: break-all;
      }
    }
  }

  /* 企业确认状态：右对齐小字，已确认深色突出 / 未确认灰色 */
  .confirm-time {
    margin-top: 20px;
    text-align: right;
    font-size: 24px;

    &.confirmed {
      color: #333;
      font-weight: 600;
    }

    &.unconfirmed {
      color: #999;
    }
  }
}

/* 底部固定返回按钮 */
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);

  .back-btn {
    width: 100%;
    font-size: 30px;
    height: 76px;
    border-radius: 999px;
  }
}
</style>
